var a="7.0.1",e={version:a};export{e as default,a as version};
